(function() {
    'use strict';

    angular.module("imApp").factory("ediOrderHeadsService", ['$ihttp', function ($ihttp) {
        var service = {

            getSetting: function (parms) {
                return $ihttp.post({
                    method: 3668,
                    parameters: parms || {}
                });
            },
            getStatusList: function (parms) {
                return $ihttp.post({
                    method: 3669,
                    parameters: parms || {}
                });
            }
        }
        
        return service;
    }]);
})();
